import React, { Component } from 'react';
import './authentication.css';
import logoImage from '../../resources/images/autofact-logo.svg';
import { FormGroup, ControlLabel, FormControl, Button, Grid, Row, Col, Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { setCode } from "../../redux/actionCreators";
import { connect } from "react-redux";


class Authentication extends Component {

    doLogin = (event) => {
        event.preventDefault();
        const password = event.target.password.value;
        const code = this.props.code;
        this.props.login(code, password);
    };

    getImage = () => {
        let result = <Image src={logoImage} />;
        if (this.props.companyLogo) {
            result = (
                <div className='content-logo'>
                    <div className='top-logo'>
                        <Image src={this.props.companyLogo} />
                    </div>
                </div>
            );

        }
        return result;
    }

    getDescriptionContent = () => {
        if (this.props.passwordType === 'PROCESS_PASSWORD') {
            return (
                <p className={'welcome-description'}>
                    Para acceder al sistema debe ingresar la clave indicada en el correo enviado con asunto <b>"Documentos a Firmar"</b>
                </p>
            );
        } else {
            return (
                <p className={'welcome-description'}>
                    Para acceder al sistema debe ingresar la <strong>clave diaria</strong> asignada a usted para el día de hoy. Éste se ha enviado a su teléfono vía SMS.
                </p>
            );
        }
    };

    getWelcomeLabel = () => {
        if (this.props.passwordType === 'PROCESS_PASSWORD') {
            return (
                <ControlLabel className={'welcome-label'}>
                    INGRESE LA <strong>CLAVE DEL PROCESO</strong> PARA ACCEDER.
                </ControlLabel>
            );
        } else {
            return (
                <ControlLabel className={'welcome-label'}>
                    INGRESE SU <strong>CLAVE DIARIA</strong> PARA ACCEDER.
                </ControlLabel>
            );
        }
    };


    render() {
        return (
            <div className={'authentication'}>
                <div className={'content'}>
                        <Row className={'image-content'}>
                            <Col xs={12}>
                                {this.getImage()}
                            </Col>
                        </Row>
                </div>
                <Grid>
                    <div className={'content'}>
                        <Row>
                            <form onSubmit={this.doLogin} ref={form => this.form = form}>
                                <Col xs={12}>
                                    <p className={'welcome-text'}>
                                        Bienvenid@
                                    </p>
                                    <div className={'description-content'}>
                                        {this.getDescriptionContent()}
                                    </div>
                                    <div className={'form-content'}>
                                        <FormGroup className={'input-content'}>
                                            {this.getWelcomeLabel()}
                                            <FormControl
                                                className={'code-input'}
                                                type={'password'}
                                                name={'password'}
                                                placeholder={'clave'}
                                            />
                                        </FormGroup>
                                    </div>
                                </Col>
                                <Col>
                                    <Button type={'submit'} className={'welcome-start-button'} >
                                        Ingresar
                                    </Button>
                                </Col>
                            </form>
                        </Row>
                    </div>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        code: state.code,
        passwordType: state.passwordType,
        companyLogo: state.companyLogo,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setCode(code) {
            dispatch(setCode(code));
        },
    };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authentication));
